export default "__VITE_ASSET__DMWI3HUy__"